export default __webpack_public_path__ + "static/media/post.8a248a0c.svg";